import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CambiarEmailService {

  @Output() msjCambiarEmail = new EventEmitter();

  constructor(private http: HttpClient) { }

  sendEmail(email: FormData): Observable<any>{
    return this.http.post(`${environment.urlApi}actualizarMail/updateMail`, email);
  }   
}
